import { PaginadoUsuarios, Usuario } from '../../pages/usuarios/models/usuario.type'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'

export const usuariosApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP de usuarios.
     * Los filtros de busqueda y los cuerpos se normalizan a snake_case antes de enviarse.
     */
    recuperarUsuarios: builder.query<
      PaginadoUsuarios,
      { pagina: number; registrosPorPagina: number; nombre?: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_USUARIOS}`,
          params: keysToSnake(arg),
        }
      },
    }),
    /**
     * Busca usuarios para asignaciones, filtrando opcionalmente por sitio o division.
     */
    recuperarUsuarioAutocomplete: builder.query<
      Usuario[],
      { nombre?: string; idSitio?: string; divisionNegocio?: string }
    >({
      query: (arg) => {
        const { nombre, ...params } = arg
        return {
          url: `${window._env_.API_CONTEXTO_USUARIOS}/autocompletar/${arg.nombre}`,
          params: keysToSnake(params),
        }
      },
    }),
    recuperarUsuarioPorId: builder.query<Usuario, string>({
      query: (idUsuario) => `${window._env_.API_CONTEXTO_USUARIOS}/${idUsuario}`,
    }),
    guardarUsuario: builder.mutation({
      query: (usuario) => ({
        url: `${window._env_.API_CONTEXTO_USUARIOS}`,
        method: 'POST',
        body: keysToSnake(usuario),
      }),
    }),
    actualizarUsuario: builder.mutation({
      query: ({ idUsuario, ...usuario }) => {
        return {
          url: `${window._env_.API_CONTEXTO_USUARIOS}/${idUsuario}`,
          method: 'PATCH',
          body: keysToSnake(usuario),
        }
      },
    }),
    /**
     * Actualiza la clave del usuario desde ajustes/perfil.
     */
    actualizarClave: builder.mutation({
      query: (args) => {
        return {
          url: `${window._env_.API_CONTEXTO_USUARIOS}`,
          method: 'PUT',
          body: keysToSnake(args),
        }
      },
    }),
  }),
})

export const {
  useRecuperarUsuariosQuery,
  useRecuperarUsuarioPorIdQuery,
  useGuardarUsuarioMutation,
  useActualizarUsuarioMutation,
  useLazyRecuperarUsuarioAutocompleteQuery,
  useActualizarClaveMutation,
} = usuariosApi
